import { useTranslation } from "react-i18next";

import { DataError, TableLoading } from "@digital-services/ui";
import { Pagination, useSortQueryString } from "@ds-cps/ui";

import { NoResultsWithIcon } from "@components/from_fota/NoResultsWithIcon";

import useGetOrganizations from "@organization/services/use-get-organizations";

import { useSearchOrganizationsContext } from "../search/context/useSearchOrganizationsContext";
import { OrganizationsTable } from "./OrganizationsTable";

export const SectionWithOrganizationsTable = () => {
  const { t: tOrganizations } = useTranslation(undefined, {
    keyPrefix: "organizations"
  });

  const { searchQuery, searchBy } = useSearchOrganizationsContext();

  const { activeSort, sortDirection, handleSort } = useSortQueryString({
    defaultSort: "name"
  });

  const { organizations, isLoading, totalCount, hasError } =
    useGetOrganizations(activeSort, sortDirection, searchQuery, searchBy);

  const noData = !hasError && (!totalCount || totalCount === 0);

  const hidePagination =
    !isLoading && noData && (!searchQuery || searchQuery?.length > 0);

  if (hasError) {
    return (
      <DataError
        message={tOrganizations("load.error.message")}
        variant="primary"
      />
    );
  }

  return (
    <>
      <div data-testid="organizations-overview-table">
        {isLoading ? (
          <>
            <TableLoading />
            <TableLoading />
          </>
        ) : noData && !searchQuery ? (
          <NoResultsWithIcon message={tOrganizations("load.none.message")} />
        ) : noData && searchQuery?.length > 0 ? (
          <NoResultsWithIcon
            message={tOrganizations("search.no-search-results")}
          />
        ) : (
          <OrganizationsTable
            organizations={organizations ?? []}
            activeSort={activeSort}
            sortDirection={sortDirection}
            handleSort={handleSort}
          />
        )}
      </div>

      {hidePagination ? null : <Pagination totalCount={totalCount!} />}
    </>
  );
};
